/**
 * give descendents the ability to log
 */
export class Loggeable {
    constructor() { }
    /**
     * log method provided to all descending classes
     */
    log(tag, msg, data) {
        if (typeof (console) !== 'undefined') {
            //console.log.apply(console, arguments);
            return "";
        }
    }
    mapping2keys(mapping) {
        const res = [];
        for (let p in mapping) {
            res.push(p);
        }
        return res;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/plugins/lib/common/loggeable.cls.ts
// module id = null
// module chunks = 